import * as React from 'react';

interface UseComposerInputHandlersOptions {
  handleInput: (e: React.SyntheticEvent<HTMLTextAreaElement>) => void;
  handlePaste: (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    value: string;
    cursorPosition: number;
  };
  setComposerText: (value: string, options?: { fromUserInput?: boolean }) => void;
  inputRef: React.RefObject<HTMLTextAreaElement | null>;
}

interface UseComposerInputHandlersReturn {
  handleTextChange: (e: React.SyntheticEvent<HTMLTextAreaElement>) => void;
  handlePasteEvent: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
}

export function useComposerInputHandlers({
  handleInput,
  handlePaste,
  setComposerText,
  inputRef,
}: UseComposerInputHandlersOptions): UseComposerInputHandlersReturn {
  const handleTextChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLTextAreaElement>) => {
      handleInput(e);
      setComposerText(e.currentTarget.value, { fromUserInput: true });
    },
    [handleInput, setComposerText],
  );

  const handlePasteEvent = React.useCallback(
    (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
      const result = handlePaste(e);
      setComposerText(result.value);

      requestAnimationFrame(() => {
        inputRef.current?.setSelectionRange(result.cursorPosition, result.cursorPosition);
      });
    },
    [handlePaste, setComposerText, inputRef],
  );

  return { handleTextChange, handlePasteEvent };
}
